import axios from 'axios'
import { Message } from 'element-ui'

const api = axios.create({
  baseURL: '/api',
  timeout: 30000,
})

// 盘点接口双鉴权：优先 Web 后台登录令牌（ems_web_token），未登录后台时回退小程序令牌（ems_mp_admin_token）。
// 用请求拦截器在每次调用时动态取值，后台登录后无需刷新即可访问盘点页。
api.interceptors.request.use(config => {
  const webToken = localStorage.getItem('ems_web_token')
  const mpToken = localStorage.getItem('ems_mp_admin_token')
  const token = webToken || mpToken
  if (token) {
    config.headers['Authorization'] = 'Token ' + token
  } else {
    delete config.headers['Authorization']
  }
  return config
})

api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response && error.response.status
    if (!status) {
      // 网络不通：请求根本没有 HTTP 响应（断网 / 超时 / DNS 失败 / 跨域被拦）
      Message.closeAll()
      Message.warning('网络无法连接后端，请检查网络或改用「手工盘点」方式先记录，恢复后请重新操作')
    } else if (status >= 500) {
      // 服务器内部错误，与网络无关，不应误报成"未连接"
      Message.closeAll()
      Message.error('服务器异常（HTTP 500），请稍后重试或联系管理员')
    } else if (status === 403) {
      Message.error('无权限：请先登录后台账号，或在「设置令牌」中粘贴小程序后勤/管理员令牌')
    }
    return Promise.reject(error)
  }
)

export default {
  // 计划列表（可 ?status=ongoing/paused/completed 过滤），含进度与盘点人姓名
  listPlans(params) {
    return api.get('/mp/inventory/', { params })
  },
  // 新建计划：{ name, planned_date, department }
  createPlan(data) {
    return api.post('/mp/inventory/', data)
  },
  // 计划详情：统计 + 未盘清单 + 盘盈清单
  getPlanDetail(pk) {
    return api.get(`/mp/inventory/${pk}/`)
  },
  // 跨科室发现清单（本计划期间发现的其他科室设备）
  getCrossDept(pk) {
    return api.get(`/mp/inventory/${pk}/cross-dept/`)
  },
  completePlan(pk) {
    return api.post(`/mp/inventory/${pk}/complete/`)
  },
  reopenPlan(pk) {
    return api.post(`/mp/inventory/${pk}/reopen/`)
  },
  // 删除计划（2026-10-16 新增）：级联删扫码记录 + 该计划全部差异 + 无码登记照片。
  // 批次已年终核对关闭(closed)时后端返回 400。
  deletePlan(pk) {
    return api.delete(`/mp/inventory/${pk}/`)
  },
  // 下载盘点确认单 PDF（blob，带鉴权头）
  downloadReport(pk) {
    return api.get(`/mp/inventory/${pk}/report/`, {
      responseType: 'blob',
      timeout: 60000,
    })
  },
  // 获取科室签字图片 URL（404 表示尚未签字）
  getSignature(pk) {
    return api.get(`/mp/inventory/${pk}/signature/`)
  },
  // 无码设备手工登记（multipart）：传入 FormData（device_name/location/device_photo/nameplate_photo...）
  registerUnlabeled(pk, formData) {
    return api.post(`/mp/inventory/${pk}/unlabeled/`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
  // 年度盘点批次列表
  listBatches() {
    return api.get('/mp/inventory/batches/')
  },
  // 按年新建/获取批次
  createBatch(data) {
    return api.post('/mp/inventory/batches/', data)
  },
  // 批次差异总表（?kind=cross_dept|pending|overage|badcode|shortage）
  getBatchDifferences(pk, params) {
    return api.get(`/mp/inventory/batches/${pk}/differences/`, { params })
  },
  // 年终核对：关闭批次并结算盘亏（幂等）
  reconcileBatch(pk) {
    return api.post(`/mp/inventory/batches/${pk}/`, {})
  },
  // 删除单条差异记录：差异表 id = diff_id || id；批次年终核对关闭后后端返回 400（detail）
  deleteDifference(id) {
    return api.delete('/mp/inventory/differences/' + id + '/')
  },
}
